"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const Icon_1 = require("../Icon/Icon");
const CheckBoxContainer = Theme_1.styled.div `
  display: flex;
  align-items: center;
  opacity: ${(props) => (props.disabled ? '.5' : '1')};
`;
const CheckBoxText = Theme_1.styled.span `
  color: ${(props) => props.theme.gray};
  font-size: ${(props) => `${props.fontSize}px`};
  line-height: 18px;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  padding-left: 8px;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
`;
exports.CheckBox = (props) => {
    const { checked, className, disabled, fontSize, onClick, text } = props;
    const checkBoxIcon = checked ? 'checkboxFilled' : 'checkboxEmpty';
    const containerClassName = className || 'checkBoxLabelContainer';
    const size = fontSize || '16';
    const onClickEvent = onClick && !disabled ? () => onClick() : undefined;
    return (react_1.default.createElement(CheckBoxContainer, { className: containerClassName, disabled: disabled },
        react_1.default.createElement(Icon_1.Icon, { icon: checkBoxIcon, size: "18", onClick: onClickEvent }),
        text && (react_1.default.createElement(CheckBoxText, { fontSize: size, onClick: onClickEvent }, text))));
};
//# sourceMappingURL=CheckBox.js.map